import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueCarousel from 'vue-carousel';

import VueAgile from 'vue-agile'

import './assets/css/tailwind.css';
import './assets/css/style.css';

Vue.config.productionTip = false

import VueTippy, {
  TippyComponent
} from "vue-tippy";

Vue.use(VueTippy);
Vue.component("tippy", TippyComponent);

Vue.use(VueCarousel);
Vue.use(VueAgile)

var filter = function (data, num) {
  
  const clamp = '...';
  // var node = document.createElement('div');
  // node.innerHTML = text;
  // var content = node.textContent;
  // return content.length > length ? content.slice(0, length) + clamp : content;

  const reqdString =
    data.split("").slice(0, num).join("");
  return reqdString.length >= num ? reqdString + clamp : reqdString;
};

Vue.filter('truncate', filter);

new Vue({
  router,
  render: function (h) { return h(App) }
}).$mount('#app')
